module.exports = __webpack_public_path__ + "assets/img/thumb-Eimele-1-Landing-Page.a6bfd0e2.jpg";